var map = {
	"./30 days.png": "mSl8",
	"./5-star.png": "6D5U",
	"./Discover.png": "Edjv",
	"./Easy to Understand Reports.png": "Zm3I",
	"./Mission.png": "3Btl",
	"./Stock Research Company.png": "BGyp",
	"./Timely Support.png": "Hsj9",
	"./Vision.png": "16Bp",
	"./acrysil-logo.png": "e4oB",
	"./acrysil.png": "Cf4I",
	"./amara-logo.png": "fvVJ",
	"./amara.png": "RIvz",
	"./article.png": "WHSB",
	"./astral-logo.png": "DaqB",
	"./astral.png": "k0Lx",
	"./atul-logo.png": "du5N",
	"./atul.png": "xhnP",
	"./cera-logo.png": "7ygC",
	"./cera.png": "m/fC",
	"./check-blue.png": "hnlM",
	"./check-purple.png": "3NF4",
	"./finolex-logo.png": "Ge6k",
	"./finolex.png": "+T65",
	"./gayatri.png": "qdfA",
	"./gulshan-logo.png": "FXAk",
	"./gws logo.png": "VWkD",
	"./gws-logo-new.png": "4sXV",
	"./gws-upi-qr-code.png": "CBWp",
	"./gws_home_testimonials copy.png": "RaNT",
	"./gws_home_testimonials.png": "j1RY",
	"./hardik.png": "AhsH",
	"./home page banner 1.png": "oon2",
	"./home page banner mobile.png": "ehao",
	"./jay.png": "Hk2S",
	"./quote1.png": "y9LE",
	"./quote2.png": "PFwi",
	"./recommendation.png": "4G/K",
	"./star.png": "F344",
	"./superhouse-logo.png": "eJaO",
	"./superhouse.png": "D8hD",
	"./suprajit-logo.png": "ZuTl",
	"./suprajit.png": "UVeJ",
	"./whats-included-latest.png": "2R0c",
	"./whats_included.png": "KDKG",
	"./zentec.png": "/NkH",
	"./zentek.png": "NRdH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 1